import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import AddEnhancedButton from 'components/ui/buttons/AddEnhancedButton';
import TenantPage from 'layouts/TenantPage';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { requestDepartmentLaboratoryService } from 'shared/services';
import { RequestLaboratoryTranscodeColumns } from '../req-department-transcodes';

export const RequestDepartmentTranscodes = () => {
  const { t } = useTranslation();
  const translationPrefix = 'pages.request-dep-lab';

  const datagridRefresh = useRef(null);

  const columns: GridColDef[] = RequestLaboratoryTranscodeColumns();

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      menuRight={<AddEnhancedButton prefix={translationPrefix} to="new" requireTenantAdmin />}>
      <EnhancedDataGrid
        columns={columns}
        service={requestDepartmentLaboratoryService}
        refresh={datagridRefresh}
      />
    </TenantPage>
  );
};

export default RequestDepartmentTranscodes;
